import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding
const getAccountData = state => state.myAccount

const onboardingGradesSelector = createSelector(
	[getOnboardingData, getAccountData],
	(onboarding, accountData) => {
		let gradesList
		try {
			gradesList = onboarding.grades.map(gradeId => accountData.data.grades.filter(gradeData => gradeId === gradeData.id)[0].value)
		} catch (err) {
			gradesList = []
		}
		return {
			gradesList,
			gradeIds: onboarding.grades,
			updated: onboarding.grades !== onboarding.saved_grades && onboarding.grades_updated,
		}
	}
)

export default onboardingGradesSelector
